export default {"src":"/_next/static/media/hotel-icon-redesign.5ee42827.svg","height":16,"width":16};